import { useOutletContext } from "react-router";

import { DutyScheduleDetailResponse } from "@/api";

import { DutyScheduleCell } from "./pages/data-entry/DutyScheduleDataEntry.utils";

// The pending edits, the selected month and the counselor filter live on the page rather than in the
// tab, because the tab pages unmount on a tab switch and would take unsaved changes with them.
export interface DutyScheduleDetailContext {
  dutySchedule: DutyScheduleDetailResponse;
  isEditable: boolean;

  selectedMonthKey: string | null;
  onSelectMonth: (monthKey: string) => void;

  // The counselor ids the table is filtered to, or null for all of them.
  counselorFilter: string[] | null;

  // The pending edit if there is one, otherwise the saved slot. undefined means no such cell exists.
  resolveCell: (date: Date, columnId: string) => DutyScheduleCell | undefined;

  onAssign: (date: Date, columnId: string, counselorId: string | null) => void;
}

export function useDutyScheduleDetailContext(): DutyScheduleDetailContext {
  return useOutletContext<DutyScheduleDetailContext>();
}
